export function isServiceDestoryedError(error: Error) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return error instanceof ServiceDestoryedError;
}

export class ServiceDestoryedError<T> extends Error {
    service: T | null = null;
    constructor(
        public readonly Service: T,
        message?: string
    ) {
        super(message || '')
        this.service = Service;
    }
}

export default class DestoryedStateService {
    destoryed$ = false;

    init$() {
        this.destoryed$ = false;
    }

    destroy$() {
        this.destoryed$ = true;
    }

    isDestoryed$() {
        if (this.destoryed$) {
            throw new ServiceDestoryedError<DestoryedStateService>(this);
        }
    }
}
